import { match, matchPath } from 'react-router'
import { createSelector } from 'reselect'
import { userIdOption } from 'src/components/UserDropdown/UserDropdown'
import { BudgetMatchParams, budgetRouteProps } from 'src/navigation/routeProps'
import { RootState } from 'src/redux/createRootReducer'
import { selectCreditCardListModelsFromState } from 'src/redux/selectors/data/creditCards.selectors'
import { selectUserListModelsFromState } from 'src/redux/selectors/data/users.selectors'
import { selectCalculatedBackgroundLocation } from 'src/redux/selectors/router.selectors'
import { UsersFullPaginatedDataState } from 'src/redux/usersFullPaginatedData.reducer'

export const selectCreditCardIdFromRoute = createSelector(
  [selectCalculatedBackgroundLocation],
  (backgroundLocation) => {
    const mtch = matchPath<BudgetMatchParams>(
      backgroundLocation.pathname,
      budgetRouteProps,
    ) as match<BudgetMatchParams>
    return mtch.params.id
  },
)

export const selectCreditCard = createSelector(
  [selectCreditCardListModelsFromState, selectCreditCardIdFromRoute],
  (creditCards, creditCardId) => {
    return creditCards[creditCardId] !== undefined
      ? creditCards[creditCardId]
      : undefined
  },
)

export const selectUsersFullPaginatedData = (
  state: RootState,
): UsersFullPaginatedDataState =>
  state.app.budget.budgetTransactions.usersFullPaginatedData
const selectUniqueUserIds = createSelector(
  [selectUsersFullPaginatedData],
  (data) => data.ids.filter((id, i) => data.ids.indexOf(id) === i),
)
const selectUniqueUserIdOptions = createSelector(
  [selectUniqueUserIds, selectUserListModelsFromState],
  (ids, users) => ids.map((id) => userIdOption(users[id])),
)
export const selectFilteredUserIdOptions = createSelector(
  [selectUniqueUserIdOptions],
  (options) => options.filter(() => true),
)

export const selectAllUsersFromState = createSelector(
  [selectUserListModelsFromState],
  (users) => Object.keys(users).map((id: string) => userIdOption(users[id])),
)
